// src/components/common/analytics/SampledFigure.tsx
//
// A rate, median or share that the API withholds below the minimum sample
// (Tiempos, Canales). With the figure: the figure. Withheld: «Muestra
// insuficiente (n = 7)», so the reader still sees how many cases there were.
// Nothing measured at all: the dash.
import React from 'react';
import { Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import { formatCount, isInsufficientSample } from '@/lib/analyticsFormat';

interface SampledFigureProps {
  value: number | null | undefined;
  /** Cases behind the figure. */
  sample: number;
  /** The minimum sample the API applies (`minimumSample` of the response). */
  minimum: number | undefined;
  format: (value: number | null | undefined) => string;
}

export const SampledFigure: React.FC<SampledFigureProps> = ({ value, sample, minimum, format }) => {
  const translate = useTranslate();
  if ((value === null || value === undefined) && isInsufficientSample(sample, minimum)) {
    return (
      <Typography component="span" variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
        {translate('common.sample.insufficient', { count: formatCount(sample) })}
      </Typography>
    );
  }
  return <>{format(value)}</>;
};
